import { STORAGE_KEYS } from '../config/constants';
import { Usuario } from '../types';

/**
 * Utilitários para gerenciamento de storage (localStorage e sessionStorage)
 */

export class StorageService {
  /**
   * Obtém o token de autenticação
   */
  static getToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.TOKEN) || sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  }

  /**
   * Salva o token de autenticação
   */
  static setToken(token: string, remember: boolean = false): void {
    if (remember) {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
      sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
    } else {
      sessionStorage.setItem(STORAGE_KEYS.TOKEN, token);
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
    }
  }

  /**
   * Remove o token de autenticação
   */
  static removeToken(): void {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
  }

  /**
   * Obtém os dados do usuário
   */
  static getUser(): Usuario | null {
    let userData = localStorage.getItem(STORAGE_KEYS.USER);
    if (!userData) {
      userData = sessionStorage.getItem(STORAGE_KEYS.USER);
    }
    
    if (!userData) return null;
    
    try {
      return JSON.parse(userData);
    } catch {
      return null;
    }
  }

  /**
   * Salva os dados do usuário
   */
  static setUser(user: Usuario, remember: boolean = false): void {
    const userData = JSON.stringify(user);
    if (remember) {
      localStorage.setItem(STORAGE_KEYS.USER, userData);
      sessionStorage.removeItem(STORAGE_KEYS.USER);
    } else {
      sessionStorage.setItem(STORAGE_KEYS.USER, userData);
      localStorage.removeItem(STORAGE_KEYS.USER);
    }
  }

  /**
   * Remove os dados do usuário
   */
  static removeUser(): void {
    localStorage.removeItem(STORAGE_KEYS.USER);
    sessionStorage.removeItem(STORAGE_KEYS.USER);
  }

  /**
   * Limpa todos os dados de autenticação
   */
  static clearAuth(): void {
    this.removeToken();
    this.removeUser();
  }

  /**
   * Obtém um valor do localStorage
   */
  static getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Salva um valor no localStorage
   */
  static setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Remove um valor do localStorage
   */
  static removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Limpa todo o localStorage
   */
  static clear(): void {
    localStorage.clear();
    sessionStorage.clear();
  }
}

